import React from "react";
import { useLocale } from "@/lib/locale";
import { Globe, ExternalLink } from "lucide-react";

const COUNTRY_NAMES = {
  US: "United States", GB: "United Kingdom", TR: "Türkiye", DE: "Germany",
  FR: "France", JP: "Japan", BR: "Brazil", IN: "India", ES: "Spain",
  MX: "Mexico", IT: "Italy", NL: "Netherlands", AU: "Australia", CA: "Canada",
  SE: "Sweden", NO: "Norway", KR: "South Korea", AR: "Argentina",
  PL: "Poland", PT: "Portugal",
};

export default function GlobalAvailability({ availability, userCountry, platformsMap }) {
  const { t } = useLocale();
  const myAvailability = availability.filter((a) => a.country === userCountry);
  if (myAvailability.length > 0) return null;

  // group by country
  const byCountry = {};
  for (const a of availability) {
    byCountry[a.country] = byCountry[a.country] || [];
    byCountry[a.country].push(a);
  }
  const countries = Object.keys(byCountry).sort();
  if (countries.length === 0) return null;

  return (
    <div className="glass rounded-md p-5 border-l-4 border-amber" data-testid="global-availability">
      <div className="flex items-center gap-2 mb-1">
        <Globe className="h-4 w-4 text-amber" />
        <div className="text-[11px] uppercase tracking-[0.22em] text-amber font-heading">
          {t("title_unavailable")} ({userCountry})
        </div>
      </div>
      <p className="text-zinc-300 font-body text-sm mb-4">{t("title_unavailable_sub")}</p>
      <div className="flex flex-wrap gap-2">
        {countries.map((c) => (
          <div key={c} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md border border-white/10 bg-black/30">
            <span className="font-heading text-white text-sm">{COUNTRY_NAMES[c] || c}</span>
            <span className="text-zinc-600">·</span>
            <span className="text-xs text-zinc-400">
              {byCountry[c].map((a) => platformsMap?.[a.platform]?.name || a.platform).join(", ")}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
